import { render, staticRenderFns } from "./aLteAsideNavItem.vue?vue&type=template&id=42cce43e"
import script from "./aLteAsideNavItem.vue?vue&type=script&lang=js"
export * from "./aLteAsideNavItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/dem/Go/src/github.com/demget/quadroclub/web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('42cce43e', component.options)
    } else {
      api.reload('42cce43e', component.options)
    }
    module.hot.accept("./aLteAsideNavItem.vue?vue&type=template&id=42cce43e", function () {
      api.rerender('42cce43e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/aside/aLteAsideNavItem.vue"
export default component.exports